import templateStr from 'text!./templates/edit-policy-address.html';

export default (function () {
    return {
        scope: {
            label: '@?',
            readonly: '=?',
            model: '=',
            hideInputLabel: '<?',
            explicitErrorMessage: '@?',
            addressData: '<?',
            cancelAction: '&',
            changeAction: '&'
        },
        template: templateStr,

        controller: ['$scope', function ($scope) {

            $scope.submitEditPolicyForm = function (editPolicyForm) {
                console.log('am in submit');
                console.log(editPolicyForm);
                editPolicyForm.submitted = true;
                if (editPolicyForm.invalid) {
                    return;
                }

                $scope.changeAction({ policyAddress: $scope.addressData.baseData.policyAddress });
            };
        }]

    };
});


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/wc/directives/editPolicyAddress.js
// module id = 1309
// module chunks = 0